import React, { useState, useEffect } from "react";
import logo from "../Assets/Logo/small.png";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { logOutSuccess, updateSpecificUserDetailsKeyinState } from "../Store/auth/action";
import { useDispatch, useSelector } from "react-redux";
import { GetInitials } from "../Store/constants";
import { AdminProfile, DirectorProfile, EmployeeProfile, HodProfile, IndentProfile, ManageNotification, StoreInchargeProfile, SystemAdminProfile, UpdateNotification } from "../Repository/Api";
import { errorMsg } from "./Toastify";
import { decode } from "html-entities";
import { imagepath } from "../Repository/BaseUrl";
import _ from "lodash";

const Header = () => {
  const { first_name, desingation, access_token, user_type_value } = useSelector((state) => state?.auth?.auth);
  const auth = useSelector((state) => state?.auth?.auth);

  const token = access_token;
  const { pathname } = useLocation();
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [click, setClick] = useState(false);

  useEffect(() => {
    getProfile();
    getNotification();
  }, [id, click, pathname]);

  const [profile, setProfile] = useState({});
  const [notifcation, setNotification] = useState([]);

  const getProfile = async () => {
    const userTypesToProfileFunctions = {
      employee: EmployeeProfile,
      hod: HodProfile,
      admin: AdminProfile,
      director: DirectorProfile,
      system_admin: SystemAdminProfile,
      indent: IndentProfile,
      store_incharge: StoreInchargeProfile,
    };

    const userType = user_type_value;
    const profileFunction = userTypesToProfileFunctions[userType];
    if (!profileFunction) {
      errorMsg("Invalid user type");
      return;
    }

    try {
      const response = await profileFunction(token);
      if (response && response.statusCode === 200) {
        if (!_.isEqual(auth, { ...auth, ...response?.data })) {
          dispatch(updateSpecificUserDetailsKeyinState(response.data));
        }
        setProfile(response?.data);
      } else {
        errorMsg(response.message);
      }
    } catch (error) {
      errorMsg("An error occurred while fetching the profile.");
    }
  };
  const getNotification = async () => {
    const response = await ManageNotification(token);
    if (response && response.statusCode === 200) {
      setNotification(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  const handleUpdate = async (e, notifcation) => {
    e.preventDefault();
    setClick(true);
    const payload = {
      id: notifcation.id,
      status: "read",
    };
    const response = await UpdateNotification(payload, token);
    if (response && response.statusCode === 200) {
      if (user_type_value === "employee") {
        navigate(`/app/Staff/StaffSpecificView/${notifcation.redirect_id}`);
      } else if (user_type_value === "hod") {
        navigate(`/app/Hod/HodSpecificrequestview/${notifcation.redirect_id}`);
      } else if (user_type_value === "admin") {
        navigate(`/app/admin/AdminSpecificrequestview/${notifcation.redirect_id}`);
      } else if (user_type_value === "director") {
        navigate(`/app/Director/DirectorSpecificrequestview/${notifcation.redirect_id}`);
      }
    } else {
      errorMsg(response.message);
    }
    setClick(false);
  };
  const logout = () => {
    dispatch(logOutSuccess());
  };

  return (
    <section className="header-bg">
      <div className="header">
        <div className="row">
          <div className="col-lg-6">
            <img
              className="headerlogo"
              src={logo}
              alt="NITTTR"
              onClick={() => {
                navigate("/app/dashboard");
              }}
            />
          </div>
          <div className="col-lg-6 my-auto">
            <div className="headeralign">
              <div className="headerflex">
                {profile?.user_type_value === "employee" || profile?.user_type_value === "hod" || profile?.user_type_value === "admin" ? (
                  // || profile?.user_type_value === "director"
                  <div>
                    <div className="dropdown">
                      <Link to="#" className="position-relative" data-bs-toggle="dropdown" aria-expanded="false">
                        <span className="material-symbols-outlined headerbaricon">notifications_active</span>
                        <span className="position-absolute translate-middle badge rounded-pill batchstyle">
                          {notifcation.filter((notify) => notify.status === "un_read").length}
                          <span className="visually-hidden">unread messages</span>
                        </span>
                      </Link>
                      <ul className={`dropdown-menu ${notifcation?.length > 0 ? "dropdownlist" : ""}`}>
                        {notifcation?.length > 0 ? (
                          <li>
                            {notifcation &&
                              notifcation.map((notify, index) => {
                                return notify.status ? (
                                  <>
                                    {notify?.redirect_path === "specific_leave_page" ? (
                                      <>
                                        <div className="dropdown-item" key={index} onClick={(e) => handleUpdate(e, notify)}>
                                          <div className="readmsg">
                                            <div className="row">
                                              <div className="col-lg-2 col-2 p-0">
                                                <span className="material-symbols-outlined notifyicon">account_circle</span>
                                              </div>
                                              <div className="col-lg-10 mt-1 col-10 p-0">
                                                <h6 className="notifyname">{notify?.title}</h6>
                                                <p
                                                  className="notifymsg"
                                                  dangerouslySetInnerHTML={
                                                    {
                                                      __html: decode(notify?.message),
                                                    }
                                                      ? {
                                                          __html: decode(notify?.message),
                                                        }
                                                      : "N/A"
                                                  }
                                                ></p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  <Link className="dropdown-item" key={index} to={`/app/Staff/StaffSpecificView/${notify.redirect_id}`}>
                                    <div className="unreadmsg">
                                      <div className="row">
                                        <div className="col-lg-2 col-2 p-0">
                                          <span className="material-symbols-outlined notifyicon">account_circle</span>
                                        </div>
                                        <div className="col-lg-10 mt-1 col-10 p-0">
                                          <h6 className="notifyname">{notify?.title}</h6>
                                          <p
                                            className="notifymsg"
                                            dangerouslySetInnerHTML={
                                              {
                                                __html: decode(notify?.message),
                                              }
                                                ? {
                                                    __html: decode(notify?.message),
                                                  }
                                                : "N/A"
                                            }
                                          ></p>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                );
                              })}
                          </li>
                        ) : (
                          <div className="no-notification">
                            <p className="mb-0">You have no notifications.</p>
                          </div>
                        )}
                      </ul>
                    </div>
                  </div>
                ) : null}

                <div>
                  <div className="dropdown">
                    <div data-bs-toggle="dropdown" aria-expanded="false">
                      {!profile?.profile_image ? <div className="messageimageletternavbar">{GetInitials(profile?.first_name)}</div> : null}
                      <img className="userprofilenavbar" src={`${imagepath}${profile?.profile_image}`} alt="" hidden={!profile?.profile_image} />
                    </div>
                    <ul className="dropdown-menu dropalign">
                      <li>
                        <Link className="dropdown-item" to="/app/Profile">
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/ChangePassword">
                          Change Password
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/Login" id="logout-hover" onClick={logout}>
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
